import { Grid, Stack, TextField } from '@mui/material';
import React from 'react';

import { FieldEditorSection } from '../types/FieldEditorSection';
import { CheckboxWithLabel } from './CheckboxWithLabel';
import { InputArea } from './InputArea';

export function FieldFlagsSettings({ field, setField }: FieldEditorSection) {
  return (
    <Stack gap={5}>
      <InputArea
        name="Flags"
        description="Flags that determine how this field behaves"
      >
        <Grid container flexWrap="wrap" gap={1}>
          <CheckboxWithLabel
            label="Required"
            checked={field.required ?? false}
            setChecked={(v) => setField({ ...field, required: v })}
          />
          <CheckboxWithLabel
            label="Sortable"
            checked={field.sortable ?? false}
            setChecked={(v) => setField({ ...field, sortable: v })}
          />
          <CheckboxWithLabel
            label="Groupable"
            checked={field.groupable ?? false}
            setChecked={(v) => setField({ ...field, groupable: v })}
          />
          <CheckboxWithLabel
            label="Multiple"
            checked={field.multiple ?? false}
            setChecked={(v) => setField({ ...field, multiple: v })}
          />
        </Grid>
        <InputArea
          name="Order"
          description="The order in which this field should appear. All fields of an entity are sorted based off their order value."
        >
          <TextField
            label="Order"
            size="small"
            value={field.order ?? 0}
            onChange={(e) =>
              setField({ ...field, order: Number(e.target.value) })
            }
          />
        </InputArea>
      </InputArea>
      <InputArea
        name="Default"
        description="The default value for this field. Leave blank for no default. (Note: required fields will NOT require users to enter a value if a default is set)"
      >
        <TextField
          label="Value"
          value={field.default ?? ''}
          onChange={(e) => setField({ ...field, default: e.target.value })}
        />
      </InputArea>
      <InputArea name="Display Name" description="The name to display to users">
        <TextField
          label="Display Name"
          value={field.ui?.name ?? ''}
          onChange={(e) =>
            setField({
              ...field,
              ui: { ...field.ui, name: e.target.value },
            })
          }
        />
      </InputArea>
    </Stack>
  );
}
